import { render, staticRenderFns } from "./LoaderCustom.vue?vue&type=template&id=5687ed83&scoped=true"
import script from "./LoaderCustom.vue?vue&type=script&lang=js"
export * from "./LoaderCustom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5687ed83",
  null
  
)

export default component.exports